const roleList = {
  tableList: [
    {
      id: 1,
      text: "No",
      name: "sNo",
      visible: true,
      className: "text-center",
    },
    {
      id: 2,
      text: "Role",
      name: "name",
      visible: true,
      className: null,
    },
    {
      id: 4,
      text: "Role Code",
      name: "id",
      visible: true,
      className: null,
    },
    {
      id: 5,
      text: "Status",
      name: "status",
      visible: true,
      className: null,
    },
    {
      id: 6,
      text: "Action",
      name: "action",
      visible: true,
      className: null,
    },
  ],
};

const roleForm = {
  feilds: [
    {
      id: 0,
      name: "newRole",
      text: "Add New Role",
      visible: true,
      element: "label",
      value: null,
      className: [],
      required: false,
    },
    {
      id: 1,
      name: "roleName",
      text: "Enter Role Name",
      visible: true,
      element: "input",
      required: true,
      input_type: "text",
      placeholder: "Enter Role Name",
      icon: "user",
      rules: [
        {
          test: (value) => {
            return value.length > 0;
          },
          message: "Please Enter Your Role Name",
        },
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: false,
      className: [],
    },
    {
      id: 21,
      name: "rolePageTable",
      text: "Add Role",
      visible: true,
      required: false,
      element: "table",
      input_type: "button",
      disable: false,
      colums: [
        {
          id: 1,
          name: "Page Name",
        },
        {
          id: 2,
          name: "View",
        },
        {
          id: 3,
          name: "Edit",
        },
        {
          id: 6,
          name: "Add",
        },
        {
          id: 4,
          name: "Delete",
        },
        {
          id: 5,
          name: "Download",
        },
      ],
    },
    {
      id: 20,
      name: "button",
      text: "Add Role",
      visible: true,
      required: false,
      element: "button",
      input_type: "button",
      disable: false,
    },
  ],
};

export { roleList, roleForm };
